import { ListParams } from "../models/listParams";
import { PagedResult } from "../models/pagedResult";
import { userManagementService } from "./user-management.service";

export class BaseService {
  private static readonly DEFAULT_PAGE_SIZE = 100;

  protected isForbiddenError(error: any): boolean {
    const status = error?.status
      ?? error?.response?.status
      ?? error?.cause?.status;
    return status === 403;
  }

  protected getOrganisatieOrReject(): Promise<{ id: string }> {
    const organisatie = userManagementService.getStoredOrganisatie();
    return organisatie && organisatie.id
      ? Promise.resolve(organisatie)
      : Promise.reject("No organisatie found in localstorage");
  }

  // Haalt alle pagina's op via een paged endpoint totdat er geen items meer zijn of de count is bereikt.
  protected async fetchAllPages<T>(
    fetchPage: (params: ListParams) => Promise<any>,
    params: ListParams = {}
  ): Promise<PagedResult<T>> {
    const usesUnderscoreParams = params?._offset !== undefined || params?._limit !== undefined;
    const requestedOffset = (usesUnderscoreParams ? params?._offset : params?.offset) ?? 0;
    const requestedPageSize = (usesUnderscoreParams ? params?._limit : params?.limit)
      ?? BaseService.DEFAULT_PAGE_SIZE;
    const effectivePageSize = requestedPageSize > 0 ? requestedPageSize : BaseService.DEFAULT_PAGE_SIZE;

    const allItems: T[] = [];
    let offset = requestedOffset;
    let totalCount: number | null = null;

    while (true) {
      const pageParams: ListParams = usesUnderscoreParams
        ? { ...params, _offset: offset, _limit: effectivePageSize }
        : { ...params, offset, limit: effectivePageSize };

      const data = await fetchPage(pageParams);
      const items: T[] = Array.isArray(data?.items) ? data.items : [];

      if (typeof data?.count === 'number') {
        totalCount = data.count;
      }

      if (items.length === 0) {
        break;
      }

      allItems.push(...items);
      offset += items.length;

      if (totalCount !== null && offset >= totalCount) {
        break;
      }

      if (items.length < effectivePageSize) {
        break;
      }
    }

    return {
      count: allItems.length,
      offset: requestedOffset,
      limit: effectivePageSize,
      items: allItems,
    };
  }
}
